import { render, staticRenderFns } from "./YourQuotesPage.vue?vue&type=template&id=12c52d68&scoped=true&"
import script from "./YourQuotesPage.vue?vue&type=script&lang=js&"
export * from "./YourQuotesPage.vue?vue&type=script&lang=js&"
import style0 from "./YourQuotesPage.vue?vue&type=style&index=0&id=12c52d68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c52d68",
  null
  
)

export default component.exports